// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import Element from 'element-ui'
import animated from 'animate.css'
// import Cookies from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
// import { Swipe, SwipeItem } from 'vant';

import * as filters from './filters' // global filters

import store from './store'
Vue.use(animated)
Vue.use(Element)
// Vue.use(Swipe);
// Vue.use(SwipeItem);
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    console.log('path', window.location)
  }
})



// WEBPACK FOOTER //
// ./src/main.js